<template>
  <div style="height: 100%; min-height: 100vh" class="q-pa-md">
    <center class="wrapper">
      <div>
        <img :src="survey.logo" style="max-width: 150px; max-height: 100px" class="mt-20" />
        <div class="text q-mt-lg">
          <img src="survey/survey_answered.svg" class="q-mt-xl" style="width: 290px" />
          <div class="flex justify-center q-mt-xl">
            <img src="survey/answered.svg" style="width: 45px; margin-top: -3px" />
            <div class="answered q-ml-md">{{ $t("survey.web.already_answered") }}</div>
          </div>
          <div class="thank q-mt-lg q-mb-lg">{{ $t("survey.web.thank_availability") }}</div>
          <div class="push"></div>
        </div>
      </div>
    </center>

    <div class="footer text-center">
      <img class="img" src="logo.png" style="" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    survey: Object
  },
  created() {
    this.setBrowserLanguage();
  }
};
</script>

<style scoped>
.text {
  max-width: 800px;
  margin: 0 auto;
}

.answered {
  color: #3d6191;
  font-weight: bold;
  font-size: 35px;
  text-transform: uppercase;
}

.thank {
  color: #4f4f4f;
  font-size: 22px;
}
.wrapper {
  min-height: 100%;
  margin-bottom: -60px;
  min-height: 100vh;
  /* margin-bottom: 20px; */
}
.footer,
.push {
  height: 50px;
  position: relative;
}

.img {
  margin-top: 20px;
  width: 100px;
  height: auto;
}
</style>
